import React, { FunctionComponent, useContext, useMemo } from 'react';

import { Asset } from '@api/v4/assets/assetTypes';
import { getAssetIsDesignHuddleAsset } from '@helpers/design_huddle';
import AttachmentListItem from './attachmentListItem';
import assetModalContext from '../asset_modal_context';
import { AttachmentActionDispatch, FlattenedAttachment } from '../EditTabTypes';

import './styles/_attachment_list.scss';

interface AttachmentListEditState {
  attachments: FlattenedAttachment[];
}

interface AttachmentListScopedContext {
  dispatch: AttachmentActionDispatch;
  state: {
    initialData: {
      asset: Asset;
    },
    editState: AttachmentListEditState;
  };
}

const AttachmentList: FunctionComponent = () => {
  const { dispatch, state }: AttachmentListScopedContext = useContext(assetModalContext);
  const { attachments }: AttachmentListEditState = state.editState;

  const isDesignHuddleAsset = getAssetIsDesignHuddleAsset(state?.initialData?.asset?.design_huddle_editor_link);

  return useMemo(() => (
    <ul className="attachment-list">
      {(attachments.map((attachment, i) => (
        <AttachmentListItem
          key={attachment.key}
          attachment={attachment}
          dispatch={dispatch}
          index={i}
          isDesignHuddleAsset={isDesignHuddleAsset}
        />
      )))}
    </ul>
  ), [attachments, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default AttachmentList;
